import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import base_resources from './translations/base'
import baseUSFlow_resources from './translations/base-us-flow'
import cle_resources from './translations/cle'
import lcr_resources from './translations/lcr'
import vde_resources from './translations/vde-fr'
import nua_resources from './translations/nua'
import fde_resources from './translations/fde'
import ebd_resources from './translations/ebd'

const lang = 'en'

const resources = {
  en: {
    translation: {
      ...base_resources.en,
    },
    cle: {
      ...cle_resources.en,
    },
    lcr: {
      ...lcr_resources.en,
    },
    vde: {
      ...vde_resources.en,
    },
    nua: {
      ...baseUSFlow_resources.en,
      ...nua_resources.en,
    },
    fde: {
      ...baseUSFlow_resources.en,
      ...fde_resources.en,
    },
    ebd: {
      ...baseUSFlow_resources.en,
      ...ebd_resources.en,
    },
  },
  fr: {
    translation: {
      ...base_resources.fr,
    },
    cle: {
      ...cle_resources.fr,
    },
    lcr: {
      ...lcr_resources.fr,
    },
    vde: {
      ...vde_resources.fr,
    },
    nua: {
      ...baseUSFlow_resources.en,
      ...nua_resources.en,
    },
    fde: {
      ...baseUSFlow_resources.en,
      ...fde_resources.en,
    },
    ebd: {
      ...baseUSFlow_resources.en,
      ...ebd_resources.en,
    },
  },
}

i18n.use(initReactI18next).init({
  resources,
  debug: process.env.NODE_ENV === 'development',
  lng: lang,
  fallbackNS: 'translation',
  interpolation: {
    escapeValue: false,
  },
})

export default i18n
